export default {
  API_ENDPOINT: `https://floating-cove-02750.herokuapp.com/api/expenses`,
  TOKEN_KEY: 'expensity-client-auth-token',
};